import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { errorHandl } from '../../../utils/network-utils';

@Injectable({
  providedIn: 'root'
})
export class DynamicFareServiceService {

  constructor(private http: HttpClient) {
  }

  getDynamicFareList(queryParams): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_DYNAMIC_FARE_LIST, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getDynamicFareById(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.GET_DYNAMIC_FARE_LIST + '/' + id)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveDynamicFare(data, id?): Observable<any> {

    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.GET_DYNAMIC_FARE_LIST + '/' + id, data).pipe(
        catchError(errorHandl)
      );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.GET_DYNAMIC_FARE_LIST, data).pipe(
        catchError(errorHandl)
      );
    }

  }


}
